export default __webpack_public_path__ + "static/media/BLON.9785b586.png";